<script lang="ts">

    import { browser } from "$app/environment";
    import { goto } from '$app/navigation';
    import { page } from '$app/stores';
    import { onMount } from "svelte";
	
    import pad2025 from '$lib/assets/images/pda_2025/pda_2025.png';
    import Cta from '$lib/components/Global/Cta.svelte';
    import __ from '$lib/stores/TranslationStore';


    function setLocalStoragePDA2025(name, value, hours) {
        if (!browser) return; // Prevent errors during SSR

        const expirationTime = Date.now() + hours * 60 * 60 * 1000; // Convert hours to milliseconds
        const data = { value, expires: expirationTime };
        localStorage.setItem(name, JSON.stringify(data));
    }

    function getLocalStorage(name) {
        if (!browser) return null;

        const item = localStorage.getItem(name);
        if (!item) return null;

        const data = JSON.parse(item);
        if (Date.now() > data.expires) {
            localStorage.removeItem(name); 
            return null;
        }
        return data.value;
    }
    
    var showPDA = false;

    function pda2025Close(){
        showPDA = false;
        setLocalStoragePDA2025("pda2025", "off", 48);
    }

    function showPDA2025(){
        return getLocalStorage("pda2025") == null && ($page.url.pathname.search("/simuladores") == -1 && $page.url.pathname.search("/simulador/") == -1);
    }

    function redirectPDA(){
        pda2025Close();
        goto("/simuladores");
    }

    
    onMount(() => {
        showPDA = showPDA2025();

        console.log(showPDA);
    })
   

</script>
{#if showPDA}
<div class="font-['Sora'] fixed bg-white/90 rounded-[14px] flex h-[161px] max-sm:h-[105px] top-[90px] right-[10px] max-sm:left-[5px] max-sm:right-[5px] max-sm:top-[65px]" >
	<div class="flex p-[20px] max-sm:p-[10px] max-sm:mb-[20px]">
        <div class="flex w-2/3 max-sm:w-3/4 gap-5 min-sm:gap-4">
            <div class="w-1/5 inline-block align-top mr-[5px]">
                <img src={pad2025} title="Eleito Produto do Ano 2025" alt="Eleito Produto do Ano 2025" class="max-w-[62px] sm:min-w-[88px]" />
            </div>
            <div class="w-4/5 inline-block align-top mr-[10px]">
                <div class="text-[15px] sm:text-[28px] md:text-[30px] font-[600] leading-[15px] sm:leading-[30px]">BAM! Temos uma <br /> super novidade! 💣</div>
                <div class="text-[11px] sm:text-[16px] font-[400] leading-[11px] sm:leading-[18px] mt-[6px]">Fomos o intermediário eleito<br />Produto do Ano 2025!</div>
                <div class="text-[10px] sm:text-[12px] font-[600] max-sm:text-[10px] text-[#018171] leading-[10px] sm:leading-[18px] mt-[6px]">Está a um clique de começar a <br class="block sm:hidden" /> poupar!</div>
            </div>
        </div>

        <div class="w-1/3 max-sm:w-1/4 inline-block align-top max-w-[201px] ml-[10px] max-sm:mr-[5px]">
            <Cta
					type="button"
					class="w-full max-sm:w-[98px] max-sm:rounded-[4px] rounded-[7px] text-[17px] max-sm:text-[9px] max-sm:h-4 max-sm:p-[18px]"
                    id="pda-2025-cta"
					on:click={redirectPDA}
				>
                    <span class="hidden sm:block">{$__('Simular crédito')}</span>
                    <span class="block sm:hidden">{$__('Simular agora')}</span>
				</Cta>
            <Cta
					type="button"
					class="w-full max-sm:w-[98px] max-sm:rounded-[4px] rounded-[7px] mt-[12px] max-sm:mt-[10px] bg-[#D0EADC] text-[#018171] text-[17px] max-sm:text-[9px] max-sm:h-4 max-sm:p-[18px]"
					on:click={pda2025Close}
				>
					{$__('Fechar')}
				</Cta>
        </div>
	</div>
</div>
{/if}